import Bmi from "./bmi";
import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import BmiTwl from "./bmi-twl";
import Iop from "./iop";
import Waarden from "./waarden";
import Visus from "./visus";


const Charts = () => {
    let [graphData, setGraphData] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();
    let type = searchParams.get('type');
    console.log({type})
    if(type === 'bmi-twl') {
        return (
            <BmiTwl/>
        )
    }
    if(type === 'bmi') {
        return (
            <Bmi/>
        )
    }
    if(type === 'iop') {
        return (
            <Iop/>
        )
    }
    if(type === 'visus') {
        return (
            <Visus/>
        )
    }
    if(type === 'waarden') {
        return (
            <Waarden/>
        )
    }

    return(
        <>Missing graph type</>
    )
}

export default Charts;